module.exports = __webpack_public_path__ + "static/media/tareq-ajalyakin-hET6laBablI-unsplash.80c86092.jpg";